import { GenIcon } from 'react-icons';

export { LuSettings2 as FilterIcon } from 'react-icons/lu';
export { FaCalendarAlt as DateIcon } from 'react-icons/fa';

// https://github.com/react-icons/react-icons/issues/238
// SVG => JSON using https://react-icons-json-generator.surge.sh/

const gbifLogoJson = {
  tag: 'svg',
  attr: { viewBox: '90 239.1 539.7 523.9' },
  child: [
    {
      tag: 'path',
      attr: { d: 'M325.5,495.4c0-89.7,43.8-167.4,174.2-167.4C499.6,417.9,440.5,495.4,325.5,495.4' },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        d: 'M534.3,731c24.4,0,43.2-3.5,62.4-10.5c0-71-42.4-121.8-117.2-158.4c-57.2-28.7-127.7-43.6-192.1-43.6\n\tc28.2-84.6,7.6-189.7-19.7-247.4c-30.3,60.4-49.2,164-20.1,248.3c-57.1,4.2-102.4,29.1-121.6,61.9c-1.4,2.5-4.4,7.8-2.6,8.8\n\tc1.4,0.7,3.6-1.5,4.9-2.7c20.6-19.1,47.9-28.4,74.2-28.4c60.7,0,103.4,50.3,133.7,80.5C401.3,704.3,464.8,731.2,534.3,731',
      },
      child: [],
    },
  ],
};
const gbifLogo = GenIcon(gbifLogoJson);
export const GbifLogoIcon = (props: React.ComponentPropsWithoutRef<'svg'>): React.JSX.Element =>
  gbifLogo(props);

// logo by https://www.behance.net/boriskozelev via https://www.figma.com/file/3pI8j1ZGCBbrhD56LLQnRa/12-Empty-States-Icons-(Community)?type=design&node-id=0-1&mode=design
// TODO add to attribution file
export const NoResultsImage = (props: React.HTMLAttributes<HTMLOrSVGElement>) => (
  <svg
    {...props}
    width="250"
    height="200"
    viewBox="0 0 250 200"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M207 65C210.866 65 214 68.134 214 72C214 75.866 210.866 79 207 79H167C170.866 79 174 82.134 174 86C174 89.866 170.866 93 167 93H189C192.866 93 196 96.134 196 100C196 103.866 192.866 107 189 107H178.826C173.952 107 170 110.134 170 114C170 116.577 172 118.911 176 121C179.866 121 183 124.134 183 128C183 131.866 179.866 135 176 135H93C89.134 135 86 131.866 86 128C86 124.134 89.134 121 93 121H54C50.134 121 47 117.866 47 114C47 110.134 50.134 107 54 107H94C97.866 107 101 103.866 101 100C101 96.134 97.866 93 94 93H69C65.134 93 62 89.866 62 86C62 82.134 65.134 79 69 79H109C105.134 79 102 75.866 102 72C102 68.134 105.134 65 109 65H207ZM207 93C210.866 93 214 96.134 214 100C214 103.866 210.866 107 207 107C203.134 107 200 103.866 200 100C200 96.134 203.134 93 207 93Z"
      fill="#F3F7FF"
    />
    <path
      d="M120.5 133C139.002 133 154 118.002 154 99.5C154 80.9985 139.002 66 120.5 66C101.998 66 87 80.9985 87 99.5C87 118.002 101.998 133 120.5 133Z"
      fill="#F3F7FF"
      stroke="rgb(var(--color300))"
      strokeWidth="2.5"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M115.132 125.494C116.891 125.819 118.68 125.987 120.5 126C135.136 126 147 114.136 147 99.5C147 84.8645 135.136 73 120.5 73C116.74 73 113.164 73.7829 109.924 75.1946C104.294 77.6479 99.6816 81.9999 96.896 87.4419C95.0445 91.0589 94 95.1575 94 99.5C94 103.44 94.8599 107.179 96.4021 110.54C97.5032 112.94 98.9521 115.146 100.684 117.096"
      fill="white"
    />
    <path
      d="M115.132 125.494C116.891 125.819 118.68 125.987 120.5 126C135.136 126 147 114.136 147 99.5C147 84.8645 135.136 73 120.5 73C116.74 73 113.164 73.7829 109.924 75.1946C104.294 77.6479 99.6816 81.9999 96.896 87.4419C95.0445 91.0589 94 95.1575 94 99.5C94 103.44 94.8599 107.179 96.4021 110.54C97.5032 112.94 98.9521 115.146 100.684 117.096"
      stroke="rgb(var(--color300))"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
    <path
      d="M103.797 120.075C105.946 121.821 108.372 123.237 111.001 124.247"
      stroke="rgb(var(--color300))"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
    <path d="M148 126L154 132" stroke="rgb(var(--color300))" strokeWidth="2.5" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M153.03 131.03C151.138 132.923 151.138 135.992 153.03 137.884L164.116 148.97C166.008 150.862 169.077 150.862 170.97 148.97C172.862 147.077 172.862 144.008 170.97 142.116L159.884 131.03C157.992 129.138 154.923 129.138 153.03 131.03Z"
      fill="#E8F0FE"
      stroke="rgb(var(--color300))"
      strokeWidth="2.5"
    />
    <path d="M158 133L169 144" stroke="white" strokeWidth="2.5" strokeLinecap="round" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M114 88C114 99.598 123.402 109 135 109C137.278 109 139.472 108.637 141.526 107.966C138.173 116.287 130.023 122.161 120.5 122.161C107.985 122.161 97.8394 112.015 97.8394 99.5C97.8394 88.1596 106.17 78.7648 117.045 77.1011C115.113 80.2793 114 84.0097 114 88Z"
      fill="#E8F0FE"
    />
    <path
      d="M121 81C119.727 81 118.482 81.1253 117.279 81.3642M113.645 82.4761C106.804 85.3508 102 92.1144 102 100"
      stroke="rgb(var(--color200))"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
    <path
      d="M174.176 99.7773H166M180.5 92H163.324H180.5ZM187.5 92H185.279H187.5Z"
      stroke="rgb(var(--color200))"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M84.1758 121.777H76M79.5 113H62.3242H79.5ZM56.5 113H52.2788H56.5Z"
      stroke="rgb(var(--color200))"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// // TODO add to attribution file if using https://www.flaticon.com/free-icon/column_9032272?term=pillar&related_id=9032272
const pilarJson = {
  tag: 'svg',
  attr: { id: 'Layer_1', dataName: 'Layer 1', viewBox: '0 0 336.14 384.1' },
  child: [
    {
      tag: 'path',
      attr: {
        d: 'M231.2,383.95c0-2.42,0-4.18,0-5.94,0-54.03,.03-108.07-.07-162.1,0-3.63,1.1-7.57-2.56-10.71-3.16-2.72-8.99-3.96-13.16-1.84-3.23,1.64-6.39,4.13-6,8.74,.16,1.91-.1,3.85-.1,5.78,0,53.44,0,106.88,0,160.32v5.49h-29.1c0-1.93,0-3.67,0-5.41,0-55.07-.05-110.15,.08-165.22,.01-4.62-1.59-7.82-5.63-9.51-4.2-1.75-8.23-1.78-12.5,.98-4.47,2.89-4.24,7.01-4.24,11.1-.07,54.18-.05,108.37-.05,162.55,0,1.75,0,3.5,0,5.51h-28.44v-5.08c0-54.48-.05-108.96,.09-163.44,.01-5.36-1.83-9.32-6.36-11.65-4.52-2.33-9.13-1.64-13.14,1.61-.93,.75-1.87,1.88-2.12,3-.69,2.99-1.41,6.06-1.41,9.1-.08,53.44-.06,106.88-.06,160.32,0,1.92,0,3.84,0,6.43-7.9-.53-15.72,1.55-23.11-1.99-4.89-2.34-4.88-7.49-6.09-11.85-.23-.83-.04-1.77-.04-2.66,0-62.94,0-125.88,0-188.82q0-5.78,5.85-5.79c57.15,0,114.3,.05,171.46-.1,4.57-.01,5.67,1.26,5.66,5.74-.15,63.09-.02,126.18-.18,189.27-.03,10.17-4.42,16.73-16.19,16.22-3.98-.17-7.98-.03-12.58-.03Z',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        d: 'M91.52,88.59c1.32-2.52,2.49-4.43,3.35-6.47,.73-1.75,1.29-3.62,1.55-5.48,.27-1.89,.02-3.85,.09-5.78,.42-10.88-3.48-19.56-11.63-27.1-7.65-7.08-16.13-11.49-26.3-10.63-9.89,.84-19.19,4.13-25.65,12.65-3.73,4.92-1.9,10.88,2.66,14.88,3.7,3.25,10.42,2.44,14.03-1.42,3.16-3.38,13.73-4.75,19.03-1.11,3.7,2.54,6.56,10.61,5.3,15.47-1.15,4.44-3.96,6.92-7.87,9.3-11.75,7.13-24.08,7.32-36.38,3.13-5.49-1.87-10.57-5.91-14.9-9.97-3.93-3.69-7.17-8.43-9.69-13.25C.43,53.9-1.77,44.25,1.7,34.39c3.05-8.68,6.93-16.87,14.52-22.99C25.42,3.98,35.73,.09,47.37,.08,128.87-.01,210.37-.05,291.88,.12c12.05,.03,22.63,4.6,31.37,13.19,4.55,4.47,6.86,10.1,9.86,15.54,4.3,7.78,2.78,15.53,2.71,23.25-.04,3.92-2.6,7.87-4.24,11.71-4.46,10.45-12.95,17.09-22.78,21.52-8.25,3.72-17.25,4.35-26.49,2.35-5.91-1.28-10.53-4.64-15.61-7.25-4.25-2.18-6.11-10.09-4.18-15.15,4.17-10.91,16.2-13.16,24.26-4.54,2.66,2.84,9.4,3.2,13.13,.7,4.51-3.03,6.65-9.04,4.22-13.47-2.93-5.34-7.7-8.65-13.31-11.09-7.28-3.18-14.55-5.28-22.5-3.09-13.26,3.65-23.32,11.49-27.28,24.71-2.96,9.86-2.7,20.31,3.23,30.1H91.52Z',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        d: 'M45.69,111.08h246.36c-.48,10.93-.78,21.66-1.59,32.35-.13,1.78-2.12,4.14-3.85,4.92-3.34,1.51-7.09,2.92-10.68,2.93-71.7,.16-143.4,.17-215.1-.02-3.69-.01-7.84-1.45-10.92-3.5-2.16-1.44-3.9-5-4.04-7.71-.48-9.46-.19-18.97-.19-28.95Z',
      },
      child: [],
    },
  ],
};
const pilar = GenIcon(pilarJson);
export const PilarIcon = (props: React.ComponentPropsWithoutRef<'svg'>): React.JSX.Element =>
  pilar(props);

const modifyPolygonJson = {
  tag: 'svg',
  attr: {
    viewBox: '0 0 100 100',
  },
  child: [
    {
      tag: 'path',
      attr: {
        d: 'M42.02 3.424c-4.29 0-8.477 2.182-10.8 6.12c-2.57 4.362-2.164 9.697.583 13.612l-12.567 12.42a3.5 3.5 0 0 0-.045-.015c-5.843-3.011-13.169-.999-16.546 4.73c-3.5 5.935-1.5 13.686 4.435 17.186c3.463 2.042 7.543 2.2 11.037.806l12.74 19.137c-1.964 2.217-3.171 5.117-3.171 8.287c0 6.89 5.659 12.55 12.548 12.55c6.358 0 11.61-4.835 12.389-10.993l2.137-.76l-1.42-3.99l-.947.338a12.608 12.608 0 0 0-2.155-4.623l.184.142l32.683-40.256a12.41 12.41 0 0 0 3.64.594l-.071 1.4l4.226.207l.11-2.248c2.779-.922 5.254-2.789 6.845-5.488c3.38-5.733 1.591-13.125-3.882-16.777a3.5 3.5 0 0 0-.555-.408a3.5 3.5 0 0 0-.639-.293c-5.843-3.011-13.169-.999-16.547 4.73c-.068.115-.12.235-.183.352l-21.504-4.715c-.168-3.901-2.153-7.663-5.586-9.953a3.5 3.5 0 0 0-.553-.409a3.5 3.5 0 0 0-.638-.293a12.526 12.526 0 0 0-5.748-1.39zm.2 6.93c.894.035 1.795.29 2.632.783c2.676 1.578 3.538 4.925 1.96 7.601c-1.577 2.676-4.923 3.54-7.6 1.961c-2.675-1.578-3.54-4.923-1.962-7.6c1.085-1.84 3.006-2.823 4.97-2.745zM87.233 20.64a5.6 5.6 0 0 1 2.631.783c2.676 1.578 3.541 4.925 1.963 7.601c-1.578 2.677-4.925 3.541-7.601 1.963c-2.677-1.578-3.54-4.925-1.961-7.601c1.084-1.84 3.004-2.824 4.968-2.746zm-34.375 1.623l21.684 4.752a12.686 12.686 0 0 0 2.793 7.107L44.9 74.073a12.32 12.32 0 0 0-4.666-.915a12.4 12.4 0 0 0-3.468.504L23.652 53.971c.216-.3.423-.606.614-.93c2.362-4.007 2.193-8.82.011-12.605l13.05-12.899c5.648 2.28 12.337.15 15.517-5.244l.013-.03zM13.643 41.102a5.6 5.6 0 0 1 2.63.783c2.677 1.578 3.541 4.923 1.963 7.6c-1.578 2.675-4.923 3.54-7.6 1.962c-2.675-1.578-3.54-4.925-1.962-7.601c1.085-1.84 3.004-2.822 4.969-2.744zm72.826 3.234l-.424 8.455l4.234.211l.414-8.459l-4.224-.207zm-.63 12.682l-.048.994c-.078-.002-.154-.012-.232-.012c-6.89 0-12.551 5.66-12.551 12.549c0 1.647.331 3.22.918 4.666l-4.62 1.64l1.415 3.987l5.51-1.95c2.304 2.572 5.634 4.208 9.328 4.208c6.65 0 12.103-5.288 12.478-11.85a3.5 3.5 0 0 0 .07-.701a3.5 3.5 0 0 0-.07-.694c-.284-5.024-3.55-9.292-8.047-11.023l.08-1.598l-4.23-.216zM85.56 65c3.106 0 5.548 2.442 5.548 5.549c0 3.106-2.442 5.55-5.548 5.55c-3.107 0-5.551-2.444-5.551-5.55c0-3.107 2.444-5.549 5.55-5.549zM65.31 78.271l-7.977 2.834l1.412 3.987l7.984-2.83l-1.42-3.99zm-25.077 1.887c3.107 0 5.551 2.442 5.551 5.549s-2.444 5.55-5.55 5.55c-3.107 0-5.55-2.443-5.55-5.55c0-3.107 2.443-5.549 5.55-5.549z',
        fillRule: 'evenodd',
      },
      child: [],
    },
  ],
};
const modifyPolygon = GenIcon(modifyPolygonJson);
export const ModifyPolygonIcon = (
  props: React.ComponentPropsWithoutRef<'svg'>
): React.JSX.Element => modifyPolygon(props);

const emptyInboxJson = {
  tag: 'svg',
  attr: {
    version: '1.1',
    id: 'Layer_1',
    x: '0px',
    y: '0px',
    viewBox: '0 0 371.37 383.45',
    style: 'enable-background:new 0 0 371.37 383.45;',
  },
  child: [
    {
      tag: 'g',
      attr: {},
      child: [
        {
          tag: 'path',
          attr: {
            d: 'M12.03,383.45c-9.01-3.26-12.51-9.81-11.98-19.18c0.35-6.22,0.03-12.47,0.08-18.71c0.03-4.34,2.2-6.94,5.63-6.95\n\t\tc3.42-0.01,5.55,2.59,5.57,6.95c0.03,6.99-0.01,13.97,0.02,20.96c0.02,4.53,1.21,5.7,5.81,5.7c112.4,0.01,224.8,0.01,337.2,0\n\t\tc4.36,0,5.65-1.23,5.65-5.49c0.02-26.45,0.02-52.89,0-79.34c0-4.31-1.29-5.63-5.54-5.63c-22.33-0.03-44.66,0.02-66.99-0.05\n\t\tc-3.06-0.01-4.78,1.26-6.05,3.95c-3.94,8.33-8.13,16.55-12.06,24.88c-3.28,6.94-8.49,10.24-16.27,10.23\n\t\tc-44.91-0.1-89.82-0.1-134.73,0c-7.76,0.02-13.03-3.19-16.32-10.15c-3.94-8.33-8.15-16.54-12.06-24.88\n\t\tc-1.34-2.86-3.2-4.05-6.38-4.04c-22.08,0.09-44.16,0.04-66.24,0.05c-4.81,0-6,1.18-6.01,5.92c-0.02,9.11,0.01,18.21-0.02,27.32\n\t\tc-0.01,4.52-1.93,6.98-5.4,7.08c-3.62,0.1-5.8-2.5-5.81-7.12C0.1,302.48,0.03,290,0.19,277.53c0.03-2.68,0.66-5.45,1.5-8.02\n\t\tc15.57-47.44,31.21-94.86,46.86-142.28c2.95-8.93,7.73-12.35,17.24-12.36c26.07-0.02,52.15,0.03,78.22-0.08\n\t\tc2.11-0.01,4.42-0.66,6.29-1.66c23.31-12.57,46.6-12.69,70.08-0.46c2.4,1.25,5.34,2.08,8.03,2.1c25.57,0.16,51.15,0.09,76.72,0.1\n\t\tc10.15,0,14.76,3.32,17.95,12.98c4.18,12.65,8.38,25.3,12.4,38c0.56,1.77,0.88,4.25,0.05,5.66c-0.89,1.51-3.18,2.78-5.01,3.01\n\t\tc-3.04,0.39-4.58-1.97-5.46-4.65c-3.53-10.77-7.07-21.53-10.6-32.3c-0.85-2.6-1.71-5.21-2.55-7.81c-0.91-2.8-2.81-3.92-6.28-3.44\n\t\tc0,1.36,0,2.68,0,3.99c0,16.59-0.03,33.18,0.04,49.78c0.01,1.96,0.26,4,0.86,5.86c8.86,27.1,17.84,54.17,26.65,81.29\n\t\tc0.85,2.61,2.03,3.44,4.71,3.36c6.59-0.2,13.18-0.06,20.24-0.06c-0.73-2.38-1.32-4.38-1.97-6.35\n\t\tc-7.1-21.52-14.21-43.04-21.31-64.57c-0.31-0.95-0.7-1.89-0.85-2.86c-0.48-3.09,0.56-5.46,3.64-6.51c3.08-1.05,5.36,0.17,6.81,2.95\n\t\tc0.51,0.98,0.84,2.08,1.19,3.14c8.03,24.36,16.1,48.71,24,73.12c1.02,3.14,1.54,6.58,1.55,9.88c0.12,28.32-0.12,56.64,0.18,84.95\n\t\tc0.1,9.35-3.02,15.91-12.02,19.18C243.58,383.45,127.8,383.45,12.03,383.45z M256.02,183.55c-0.27,1.18-0.53,2.13-0.69,3.09\n\t\tc-4.53,27.35-26.3,50.52-53.22,56.63c-4.38,0.99-7.36-0.31-8.22-3.58c-0.96-3.62,0.97-6.22,5.45-7.37\n\t\tc31.45-8.05,50.43-37.31,44.79-69.05c-5.39-30.37-33.96-51.25-65.52-47.89c-33.23,3.53-57.71,35.91-51.54,68.71\n\t\tc4.74,25.21,19.97,41.12,44.56,48.16c4.25,1.22,6.07,3.75,5.17,7.22c-0.83,3.22-3.79,4.64-7.77,3.74\n\t\tc-26.51-6.03-48.53-29.27-52.82-56.07c-0.51-3.15-1.72-3.73-4.55-3.68c-9.48,0.16-18.97,0.26-28.44-0.03\n\t\tc-4.23-0.13-6.26,1.37-7.54,5.36c-6.62,20.63-13.47,41.19-20.23,61.77c-2.13,6.49-4.26,12.98-6.55,19.97c1.68,0,2.89,0,4.1,0\n\t\tc10.35,0,20.71,0.03,31.06-0.01c7.35-0.03,12.58,3.11,15.76,9.84c4.05,8.56,8.36,16.99,12.43,25.54c1.23,2.6,2.95,3.64,5.83,3.64\n\t\tc45.04-0.06,90.07-0.06,135.11,0.01c3.05,0,4.79-1.14,6.06-3.87c3.65-7.78,7.79-15.34,11.19-23.22\n\t\tc3.76-8.71,9.98-12.36,19.38-12.01c10.69,0.4,21.41,0.09,32.67,0.09c-2.5-7.62-4.86-14.8-7.22-21.98\n\t\tc-6.57-19.99-13.13-39.99-19.72-59.97c-0.73-2.21-1.21-4.95-4.27-4.97C279.58,183.5,267.87,183.55,256.02,183.55z M65.76,126.46\n\t\tc-4.28-0.95-5.64,1.35-6.68,4.52c-14.88,45.3-29.81,90.59-44.72,135.88c-0.36,1.1-0.6,2.24-0.98,3.66c7.13,0,13.73-0.14,20.33,0.07\n\t\tc2.6,0.08,3.66-0.79,4.45-3.21c8.87-27.22,17.88-54.4,26.78-81.62c0.57-1.74,0.79-3.66,0.8-5.49c0.06-16.71,0.03-33.43,0.03-50.14\n\t\tC65.76,128.91,65.76,127.69,65.76,126.46z M256.43,172.1c12.92,0,25.33,0,37.67,0c0-15.39,0-30.54,0-45.74\n\t\tc-18.77,0-37.26,0-56.44,0C249.41,139.66,255.62,154.67,256.43,172.1z M114.93,172.19c0.8-17.51,7.08-32.58,18.76-45.85\n\t\tc-19.34,0-37.84,0-56.48,0c0,15.4,0,30.55,0,45.85C89.74,172.19,102.05,172.19,114.93,172.19z',
          },
          child: [],
        },
        {
          tag: 'path',
          attr: {
            d: 'M69.47,59.9c-0.09-14.18,11.33-25.78,25.45-25.86c13.91-0.08,25.54,11.38,25.67,25.3c0.13,14.21-11.16,25.83-25.3,26.04\n\t\tC81.26,85.6,69.55,74.05,69.47,59.9z M80.69,59.63c-0.04,8.02,6.5,14.61,14.43,14.53c7.82-0.08,14.22-6.53,14.25-14.36\n\t\tc0.03-8.01-6.52-14.6-14.45-14.53C87.09,45.35,80.73,51.77,80.69,59.63z',
          },
          child: [],
        },
        {
          tag: 'path',
          attr: {
            d: 'M215.51,28.97c-0.06-12.03,9.48-21.62,21.48-21.59c11.86,0.03,21.34,9.49,21.39,21.32c0.04,11.99-9.56,21.67-21.49,21.64\n\t\tC225.09,50.32,215.57,40.79,215.51,28.97z M236.81,39.1c5.61,0.07,10.26-4.49,10.32-10.13c0.06-5.72-4.37-10.26-10.07-10.32\n\t\tc-5.73-0.07-10.25,4.35-10.31,10.07C226.7,34.41,231.17,39.02,236.81,39.1z',
          },
          child: [],
        },
        {
          tag: 'path',
          attr: {
            d: 'M147.49,22.59c-3.81,2.5-6.86,9.46-12.3,4.03c-5.49-5.48,1.62-8.45,4.05-12.28c-2.41-3.84-9.52-6.79-4.07-12.28\n\t\tc5.47-5.5,8.46,1.52,12.32,4.02c3.81-2.37,6.77-9.51,12.25-4.1c5.49,5.42-1.36,8.5-4,12.29c2.38,3.85,9.51,6.82,4.08,12.3\n\t\tC154.38,32.07,151.33,25.1,147.49,22.59z',
          },
          child: [],
        },
        {
          tag: 'path',
          attr: {
            d: 'M273.81,60.66c3.46-1.9,6.42-3.77,9.61-5.11c0.84-0.35,2.81,0.64,3.52,1.58c4.45,5.89-1.48,8.47-4.26,12.22\n\t\tc2.44,3.85,9.63,7.03,3.93,12.48c-5.28,5.05-8.35-1.46-12.11-4.2c-3.82,2.44-6.52,9.2-12.55,4.04c-2.94-2.52-1.88-5.18,4.29-12.19\n\t\tc-2.36-3.82-9.2-6.48-4.08-12.54C264.64,53.99,267.33,55.04,273.81,60.66z',
          },
          child: [],
        },
        {
          tag: 'path',
          attr: {
            d: 'M44.24,340.01c-2.99,0-5.97,0.05-8.96-0.01c-3.99-0.08-6.49-2.33-6.44-5.69c0.05-3.23,2.46-5.45,6.24-5.49\n\t\tc6.47-0.07,12.94-0.08,19.4,0.01c3.7,0.05,6.16,2.47,6.1,5.66c-0.06,3.19-2.53,5.37-6.27,5.52c-0.12,0.01-0.25,0-0.37,0\n\t\tC50.7,340.01,47.47,340.01,44.24,340.01z',
          },
          child: [],
        },
        {
          tag: 'path',
          attr: {
            d: 'M44.82,357.47c-3.36,0.01-6.71,0.1-10.06-0.02c-3.6-0.13-5.83-2.28-5.89-5.4c-0.06-3.1,2.16-5.6,5.66-5.68\n\t\tc6.83-0.17,13.67-0.18,20.5,0.01c3.41,0.09,5.71,2.79,5.56,5.8c-0.15,2.92-2.4,5.12-5.69,5.26\n\t\tC51.53,357.58,48.17,357.47,44.82,357.47z',
          },
          child: [],
        },
        {
          tag: 'path',
          attr: {
            d: 'M166.31,83.42c-0.97,1.11-2.11,3.58-3.79,4.02c-1.87,0.49-5.21-0.16-6.2-1.54c-3.62-5.03-6.68-10.5-9.66-15.96\n\t\tc-1.39-2.55-0.2-4.91,2.07-6.5c2.35-1.64,5.23-1.64,6.75,0.61c3.75,5.55,6.98,11.46,10.4,17.23\n\t\tC166.05,81.6,166.03,82.02,166.31,83.42z',
          },
          child: [],
        },
        {
          tag: 'path',
          attr: {
            d: 'M211.36,88.35c-4.92,0.18-8.02-4.1-6.09-7.76c2.84-5.38,6.09-10.58,9.48-15.64c1.76-2.64,4.64-2.92,7.29-1.23\n\t\tc2.67,1.7,3.46,4.36,1.89,7.15c-2.88,5.09-5.9,10.12-9.12,14.99C213.95,87.16,212.12,87.82,211.36,88.35z',
          },
          child: [],
        },
        {
          tag: 'path',
          attr: {
            d: 'M190.96,66.9c0,2.87,0.11,5.74-0.03,8.6c-0.16,3.23-2.48,5.48-5.45,5.52c-2.95,0.05-5.54-2.14-5.64-5.34\n\t\tc-0.18-5.73-0.17-11.47,0.04-17.2c0.12-3.27,2.6-5.31,5.65-5.27c3.08,0.04,5.27,2.15,5.43,5.46c0.13,2.74,0.03,5.48,0.03,8.22\n\t\tC190.98,66.9,190.97,66.9,190.96,66.9z',
          },
          child: [],
        },
        {
          tag: 'path',
          attr: {
            d: 'M184.75,183.46c6.19-0.09,11.81,1.63,16.71,5.45c3.04,2.37,3.62,5.46,1.68,8.15c-1.91,2.65-5.06,3.04-8.25,0.88\n\t\tc-6.63-4.47-13.22-4.47-19.88-0.09c-3.28,2.16-6.3,1.81-8.25-0.85c-2.04-2.79-1.36-5.91,1.93-8.37\n\t\tC173.44,185.09,178.82,183.41,184.75,183.46z',
          },
          child: [],
        },
        {
          tag: 'path',
          attr: {
            d: 'M216.78,162.42c3.01,0.05,5.48,2.46,5.53,5.41c0.05,3.09-2.59,5.71-5.71,5.65c-3.16-0.06-5.62-2.68-5.48-5.84\n\t\tC211.27,164.61,213.69,162.36,216.78,162.42z',
          },
          child: [],
        },
        {
          tag: 'path',
          attr: {
            d: 'M154.8,162.42c3.08,0.04,5.42,2.36,5.47,5.4c0.05,3.19-2.46,5.72-5.63,5.66c-2.96-0.05-5.47-2.53-5.54-5.46\n\t\tC149.03,164.93,151.62,162.38,154.8,162.42z',
          },
          child: [],
        },
      ],
    },
  ],
};
const emptyInbox = GenIcon(emptyInboxJson);
export const EmptyInboxIcon = (props: React.ComponentPropsWithoutRef<'svg'>): React.JSX.Element =>
  emptyInbox(props);

const clusterJson = {
  tag: 'svg',
  attr: {
    version: '1.1',
    id: 'Capa_1',
    x: '0px',
    y: '0px',
    viewBox: '-202.4 314.1 200.8 201.2',
    style: 'enable-background:new -202.4 314.1 200.8 201.2;',
  },
  child: [
    {
      tag: 'path',
      attr: {
        d: 'M-35.7,469.5c8.6-10.4,14.7-22.9,17.7-36l14.6,3.3c-3.4,15.4-10.6,30-20.8,42.3L-35.7,469.5z M-40.5,334.9\n\tc-12.6-9.7-27.5-16.3-43-19.1l-2.7,14.8c13.2,2.4,25.9,8.1,36.6,16.3L-40.5,334.9z M-198.2,385.6l14.4,4.4\n\tc3.9-12.9,10.9-24.8,20.3-34.5l-10.8-10.4C-185.3,356.4-193.6,370.5-198.2,385.6z M-168.8,490c11.8,10.6,26.2,18.3,41.5,22.3\n\tl3.8-14.5c-13-3.4-25.2-10-35.3-19L-168.8,490z M-189.7,464l13.1-7.3c-6.6-11.7-10.3-25.1-10.8-38.6l-15,0.6\n\tC-201.9,434.5-197.4,450.2-189.7,464z M-140.7,338.5c12.1-6.2,25.2-9.4,39-9.4v-15c-15.9,0-31.7,3.8-45.8,11L-140.7,338.5z\n\t M-1.7,403.5c-1.8-15.7-7.3-31-16.1-44.3l-12.5,8.3c7.5,11.2,12.2,24.3,13.7,37.6L-1.7,403.5z M-94.2,515.3\n\tc15.8-1.2,31.3-6.2,44.8-14.4l-7.8-12.8c-11.5,7-24.7,11.3-38.1,12.3L-94.2,515.3z',
      },
      child: [],
    },
    {
      tag: 'g',
      attr: {},
      child: [
        { tag: 'circle', attr: { cx: '-119.9', cy: '451.9', r: '27' }, child: [] },
        { tag: 'circle', attr: { cx: '-84.2', cy: '377.5', r: '27' }, child: [] },
      ],
    },
  ],
};
// @ts-ignore
const cluster = GenIcon(clusterJson);
export const ClusterIcon = (props: React.ComponentPropsWithoutRef<'svg'>) => cluster(props);

export const ErrorImage = (props: React.HTMLAttributes<HTMLOrSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    x="0"
    y="0"
    enableBackground="new 0 0 209.6 146.5"
    version="1.1"
    viewBox="0 0 209.6 146.5"
    xmlSpace="preserve"
  >
    <path
      d="M32.6 74.9v-1.2c0-39.5 32.1-71.6 71.6-71.6h1.2c39.5 0 71.6 32.1 71.6 71.6v1.2c0 39.5-32.1 71.6-71.6 71.6h-1.2c-39.5-.1-71.6-32.1-71.6-71.6"
      className="g-evenodd g-fill-slate-200"
      transform="translate(0 .067)"
    ></path>
    <path
      d="M78.3 26.9h30c2.6 0 4.6-2.1 4.6-4.6 0-2.6-2.1-4.6-4.6-4.6h-30c-2.6.1-4.6 2.2-4.5 4.7 0 2.5 2 4.5 4.5 4.5m11.4 18.5h30c2.6.1 4.7-2 4.7-4.5.1-2.6-2-4.7-4.5-4.7H89.7c-2.6 0-4.6 2.1-4.6 4.6 0 2.5 2.1 4.6 4.6 4.6M92.1 26.9H108c-2.6 0-4.6 2.1-4.6 4.6 0 2.6 2.1 4.6 4.6 4.6H92.1c2.5-.1 4.6-2.2 4.5-4.7 0-2.4-2-4.4-4.5-4.5m36.7 42.7h-4c-2.6 0-4.8-2.1-4.8-4.8 0-2.6 2.1-4.8 4.8-4.8h4c2.6 0 4.8 2.1 4.8 4.8-.1 2.6-2.2 4.8-4.8 4.8"
      className="g-evenodd g-fill-white"
    ></path>
    <path
      d="M150.3 29.7C150.3 13.3 163.6 0 180 0s29.6 13.3 29.6 29.7-13.3 29.7-29.7 29.7-29.6-13.3-29.6-29.7"
      className="g-evenodd g-fill-orange-600"
    ></path>
    <path
      d="M182.2 18.9l-.7 15c0 .8-.7 1.5-1.6 1.5-.8 0-1.4-.7-1.5-1.5l-.7-15c0-1.2.9-2.2 2.1-2.3 1.2 0 2.2.9 2.3 2.1.1.1.1.2.1.2m-.3 19.4c.5.5.8 1.1.8 1.9s-.3 1.4-.8 1.9c-.6.5-1.2.7-1.9.7s-1.4-.3-1.9-.8c-.6-.5-.8-1.1-.8-1.9 0-.8.3-1.4.8-1.9s1.1-.7 1.9-.7c.7.1 1.4.3 1.9.8"
      className="g-evenodd g-fill-slate-50"
    ></path>
    <path
      d="M116.3 91.2l3.7-3.7m-10.7 10.6l3.5-3.5m.8-2.9l-4.3-4.3M120 98.1l-4-4"
      className="g-fill-none g-stroke-slate-300 g-stroke-2 g-linecap-round g-linejoin-round"
    ></path>
    <path
      d="M64 103.7c-7.6 0-13.7-6.1-13.7-13.7V68.5c.1-7.6 6.3-13.7 13.9-13.6 7.3.1 13.5 6.1 13.5 13.6V90c0 7.6-6.2 13.7-13.7 13.7"
      className="g-evenodd g-fill-lime-600"
    ></path>
    <path
      d="M76.1 103.6c-7.6 0-13.7-6.1-13.7-13.7v-5c.1-7.6 6.3-13.7 13.9-13.6 7.4.1 13.6 6.1 13.6 13.6v5c-.1 7.6-6.3 13.7-13.8 13.7"
      className="g-evenodd g-fill-lime-500"
    ></path>
    <path
      d="M90.8 141.4H50.4c-2.6 0-4.7-2-4.7-4.7v-30.2c0-2.6 2-4.7 4.7-4.7h40.4c2.6 0 4.7 2 4.7 4.7v30.2c0 2.5-2.1 4.7-4.7 4.7"
      className="g-evenodd g-fill-slate-400"
    ></path>
  </svg>
);

const iiifJson = {
  tag: 'svg',
  attr: {
    version: '1.1',
    desc: 'Created with imagetracer.js version 1.2.6',
    viewBox: '0 0 1280 1280',
  },
  child: [
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0',
        d: 'M 0 0 L 1231 0.5 L 1196.5 4 L 1153.5 13 L 1124.5 22 L 1088.5 37 Q 1028.3 66.3 986 113.5 Q 938.7 165.2 919 244.5 L 914 272.5 L 914 280.5 L 913 281.5 L 911 316.5 L 910 317.5 L 910 334.5 L 909 335.5 L 909 361.5 L 908 362.5 L 908 471.5 L 909 472.5 L 909 513.5 L 910 514.5 L 910 548.5 L 911 549.5 L 911 583.5 L 912 584.5 L 912 624.5 L 913 625.5 L 913 1098 L 917.5 1098 L 943.5 1091 L 992.5 1075 L 1125.5 1023 L 1146.5 1016 L 1152 1012.5 L 1152 576.5 L 1157.5 571 L 1182.5 558 L 1236 542 L 1235.5 345 L 1188.5 363 L 1160.5 370 L 1152.5 370 L 1151 368.5 L 1151 354.5 L 1150 353.5 L 1149 308.5 L 1150 307.5 L 1151 279.5 L 1157 250.5 Q 1162.9 230.9 1176.5 219 Q 1183.8 213.3 1194.5 211 L 1213.5 211 L 1235.5 218 L 1236.5 0 L 1237 1099 L 859 1099 L 859 462.5 L 841.5 455 L 663.5 390 L 621.5 373 L 621 1009.5 L 624.5 1012 L 668.5 1029 L 858 1098.5 L 330.5 1099 L 330.5 1098 L 394.5 1072 L 525.5 1025 L 559.5 1012 L 563 1009.5 L 563 377.5 L 562.5 377 L 554.5 377 L 397.5 436 L 321 462 L 321 848.5 L 322 849.5 L 322 921.5 L 323 922.5 L 324 1005.5 L 325 1006.5 L 325 1035.5 L 326 1036.5 L 326 1061.5 L 327 1062.5 L 327 1084.5 L 328 1085.5 L 328 1099 L 260.5 1099 L 260 1098.5 L 260 462.5 L 219.5 446 L 67.5 391 L 22.5 373 L 21 374.5 L 21 1012.5 L 24.5 1015 L 50.5 1022 L 103.5 1040 L 258 1098.5 L 0 1099 L 0 0 Z M 83 75 L 82 76 L 68 77 L 55 81 Q 40 87 30 97 Q 10 115 1 144 L 1 202 Q 14 235 30 266 Q 43 289 60 310 Q 85 340 123 357 L 154 367 L 171 369 L 172 370 L 183 370 L 184 371 L 205 370 L 219 367 Q 238 361 251 349 Q 261 339 268 325 L 275 305 L 277 287 L 278 286 L 278 259 L 277 258 L 277 250 L 271 222 L 267 210 Q 255 176 233 153 Q 203 118 161 95 Q 142 85 120 79 L 104 76 L 83 75 Z M 687 76 L 653 83 Q 638 87 629 95 Q 616 106 608 121 L 599 142 L 595 162 L 596 191 L 600 209 L 608 231 Q 626 268 652 297 Q 682 330 722 353 Q 736 362 755 367 L 770 370 L 782 370 L 783 371 Q 828 370 852 348 Q 865 337 873 321 L 880 300 L 881 285 L 882 284 L 882 267 L 881 266 L 880 250 L 876 232 L 867 207 Q 850 168 822 141 Q 793 110 753 90 Q 736 82 717 78 L 703 77 L 702 76 L 687 76 Z M 479 77 L 453 82 L 426 92 Q 395 107 372 129 Q 341 157 321 195 L 308 228 L 304 245 L 303 263 L 302 264 L 303 286 L 307 306 Q 313 329 327 345 Q 338 358 355 365 L 383 372 L 411 372 Q 412 370 418 371 L 432 368 L 450 362 Q 483 348 509 325 Q 541 297 562 259 L 569 245 L 579 217 L 583 197 L 583 188 L 584 187 L 584 168 L 580 145 Q 573 120 558 105 Q 545 90 526 83 L 513 79 L 501 78 L 500 77 L 479 77 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 1231.5 0 L 1236 0.5 L 1231.5 1 L 1231.5 0 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 1220.5 1 L 1225 1.5 L 1220.5 2 L 1220.5 1 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 1210.5 2 L 1215 2.5 L 1210.5 3 L 1210.5 2 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 1203.5 3 L 1206 3.5 L 1203.5 4 L 1203.5 3 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 1196.5 4 L 1199 4.5 L 1196.5 5 L 1196.5 4 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 1190.5 5 L 1193 5.5 L 1190.5 6 L 1190.5 5 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 1184.5 6 L 1187 6.5 L 1184.5 7 L 1184.5 6 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 1179.5 7 L 1182 7.5 L 1179.5 8 L 1179.5 7 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 1174.5 8 L 1177 8.5 L 1174.5 9 L 1174.5 8 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 1078.5 42 L 1077.5 44 L 1078.5 42 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 1067.5 48 L 1066.5 50 L 1067.5 48 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 1057.5 54 L 1056.5 56 L 1057.5 54 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 1049.5 59 L 1048.5 61 L 1049.5 59 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 1046.5 61 L 1045.5 63 L 1046.5 61 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 1043.5 63 L 1042.5 65 L 1043.5 63 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 1039.5 66 L 1038.5 68 L 1039.5 66 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 1036.5 68 L 1035.5 70 L 1036.5 68 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 1032.5 71 L 1031.5 73 L 1032.5 71 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 1028.5 74 L 1026.5 77 L 1028.5 74 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 82.5 75 L 94 75.5 L 82.5 76 L 82.5 75 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 73.5 76 L 76 76.5 L 73.5 77 L 73.5 76 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 100.5 76 L 104 76.5 L 100.5 77 L 100.5 76 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 686.5 76 L 702 76.5 L 686.5 77 L 686.5 76 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 67.5 77 L 70 77.5 L 67.5 78 L 67.5 77 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 478.5 77 L 487 77.5 L 478.5 78 L 478.5 77 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 491.5 77 L 500 77.5 L 491.5 78 L 491.5 77 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 679.5 77 L 682 77.5 L 679.5 78 L 679.5 77 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 708.5 77 L 711 77.5 L 708.5 78 L 708.5 77 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 470.5 78 L 473 78.5 L 470.5 79 L 470.5 78 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 504.5 78 L 507 78.5 L 504.5 79 L 504.5 78 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 673.5 78 L 676 78.5 L 673.5 79 L 673.5 78 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 714.5 78 L 717 78.5 L 714.5 79 L 714.5 78 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 1023.5 78 L 1021.5 81 L 1023.5 78 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 464.5 79 L 467 79.5 L 464.5 80 L 464.5 79 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 510.5 79 L 513 79.5 L 510.5 80 L 510.5 79 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 1018.5 82 L 1015.5 86 L 1018.5 82 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 1011.5 88 L 1003.5 97 L 1011.5 88 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 39.5 89 L 38.5 91 L 39.5 89 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 637.5 89 L 636.5 91 L 637.5 89 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 35.5 92 L 33.5 95 L 35.5 92 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 160.5 95 L 161.5 97 L 160.5 95 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 547.5 95 L 549.5 98 L 547.5 95 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 628.5 95 L 620.5 104 L 628.5 95 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 417.5 96 L 416.5 98 L 417.5 96 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 764.5 96 L 765.5 98 L 764.5 96 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 29.5 97 L 25.5 102 L 29.5 97 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 169.5 100 L 170.5 102 L 169.5 100 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 554.5 101 L 557.5 105 L 554.5 101 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 174.5 103 L 175.5 105 L 174.5 103 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 22.5 105 L 20.5 108 L 22.5 105 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 177.5 105 L 178.5 107 L 177.5 105 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 994.5 105 L 986.5 114 L 994.5 105 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 617.5 107 L 616.5 109 L 617.5 107 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 561.5 109 L 563.5 112 L 561.5 109 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 18.5 110 L 17.5 112 L 18.5 110 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 186.5 111 L 187.5 113 L 186.5 111 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 393.5 111 L 392.5 113 L 393.5 111 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 614.5 111 L 613.5 113 L 614.5 111 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 789.5 112 L 790.5 114 L 789.5 112 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 16.5 113 L 15.5 115 L 16.5 113 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 189.5 113 L 190.5 115 L 189.5 113 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 389.5 114 L 388.5 116 L 389.5 114 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 612.5 114 L 611.5 116 L 612.5 114 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 793.5 115 L 794.5 117 L 793.5 115 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 14.5 116 L 13.5 118 L 14.5 116 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 193.5 116 L 194.5 118 L 193.5 116 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 385.5 117 L 383.5 120 L 385.5 117 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 983.5 117 L 980.5 121 L 983.5 117 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 197.5 119 L 199.5 122 L 197.5 119 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 798.5 119 L 799.5 121 L 798.5 119 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 379.5 122 L 377.5 125 L 379.5 122 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 202.5 123 L 205.5 127 L 202.5 123 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 978.5 123 L 976.5 126 L 978.5 123 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 804.5 124 L 806.5 127 L 804.5 124 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 208.5 128 L 214.5 135 L 208.5 128 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 974.5 128 L 972.5 131 L 974.5 128 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 371.5 129 L 356.5 145 L 371.5 129 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 971.5 132 L 969.5 135 L 971.5 132 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 814.5 133 L 821.5 141 L 814.5 133 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 968.5 136 L 967.5 138 L 968.5 136 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 965.5 140 L 964.5 142 L 965.5 140 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 963.5 143 L 962.5 145 L 963.5 143 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 961.5 146 L 960.5 148 L 961.5 146 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 227.5 147 L 232.5 153 L 227.5 147 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 828.5 148 L 831.5 152 L 828.5 148 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 351.5 150 L 349.5 153 L 351.5 150 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 581.5 152 L 582 154.5 L 581 154.5 L 581.5 152 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 596.5 154 L 597 156.5 L 596 156.5 L 596.5 154 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 834.5 155 L 836.5 158 L 834.5 155 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 235.5 156 L 237.5 159 L 235.5 156 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 346.5 156 L 345.5 158 L 346.5 156 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 582.5 158 L 583 161.5 L 582 161.5 L 582.5 158 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 343.5 160 L 342.5 162 L 343.5 160 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 838.5 160 L 839.5 162 L 838.5 160 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 239.5 161 L 241.5 164 L 239.5 161 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 595.5 161 L 596 168.5 L 595 168.5 L 595.5 161 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 841.5 164 L 842.5 166 L 841.5 164 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 242.5 165 L 243.5 167 L 242.5 165 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 583.5 167 L 584 186.5 L 583 186.5 L 583.5 167 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 337.5 168 L 336.5 170 L 337.5 168 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 844.5 168 L 845.5 170 L 844.5 168 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 245.5 169 L 246.5 171 L 245.5 169 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 335.5 171 L 334.5 173 L 335.5 171 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 247.5 172 L 248.5 174 L 247.5 172 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 333.5 174 L 332.5 176 L 333.5 174 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 595.5 175 L 596 182.5 L 595 182.5 L 595.5 175 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 850.5 177 L 851.5 179 L 850.5 177 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 252.5 180 L 253.5 182 L 252.5 180 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 596.5 188 L 597 190.5 L 596 190.5 L 596.5 188 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 582.5 193 L 583 196.5 L 582 196.5 L 582.5 193 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 581.5 200 L 582 202.5 L 581 202.5 L 581.5 200 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 1197.5 210 L 1210 210.5 L 1197.5 211 L 1197.5 210 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 1178.5 217 L 1177.5 219 L 1178.5 217 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 1173.5 221 L 1171.5 224 L 1173.5 221 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 1169.5 226 L 1167.5 229 L 1169.5 226 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 1166.5 230 L 1165.5 232 L 1166.5 230 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 274.5 237 L 275 239.5 L 274 239.5 L 274.5 237 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 275.5 243 L 276 245.5 L 275 245.5 L 275.5 243 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 304.5 244 L 305 246.5 L 304 246.5 L 304.5 244 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 919.5 244 L 920 246.5 L 919 246.5 L 919.5 244 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 617.5 248 L 618.5 250 L 617.5 248 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 276.5 249 L 277 252.5 L 276 252.5 L 276.5 249 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 879.5 249 L 880 251.5 L 879 251.5 L 879.5 249 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 303.5 251 L 304 254.5 L 303 254.5 L 303.5 251 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 917.5 254 L 918 256.5 L 917 256.5 L 917.5 254 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 880.5 256 L 881 259.5 L 880 259.5 L 880.5 256 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 277.5 258 L 278 266.5 L 277 266.5 L 277.5 258 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 623.5 258 L 624.5 260 L 623.5 258 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 916.5 259 L 917 261.5 L 916 261.5 L 916.5 259 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 302.5 263 L 303 273.5 L 302 273.5 L 302.5 263 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 881.5 266 L 882 283.5 L 881 283.5 L 881.5 266 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 915.5 266 L 916 268.5 L 915 268.5 L 915.5 266 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 629.5 267 L 630.5 269 L 629.5 267 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 1152.5 269 L 1153 271.5 L 1152 271.5 L 1152.5 269 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 631.5 270 L 632.5 272 L 631.5 270 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 34.5 272 L 35.5 274 L 34.5 272 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 914.5 272 L 915 275.5 L 914 275.5 L 914.5 272 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 634.5 274 L 635.5 276 L 634.5 274 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 1151.5 275 L 1152 278.5 L 1151 278.5 L 1151.5 275 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 37.5 277 L 38.5 279 L 37.5 277 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 277.5 278 L 278 285.5 L 277 285.5 L 277.5 278 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 637.5 278 L 638.5 280 L 637.5 278 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 913.5 281 L 914 285.5 L 913 285.5 L 913.5 281 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 303.5 282 L 304 285.5 L 303 285.5 L 303.5 282 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 546.5 282 L 545.5 284 L 546.5 282 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 641.5 283 L 642.5 285 L 641.5 283 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 1150.5 283 L 1151 288.5 L 1150 288.5 L 1150.5 283 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 543.5 286 L 542.5 288 L 543.5 286 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 645.5 288 L 648.5 292 L 645.5 288 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 304.5 290 L 305 292.5 L 304 292.5 L 304.5 290 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 540.5 290 L 539.5 292 L 540.5 290 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 880.5 290 L 881 293.5 L 880 293.5 L 880.5 290 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 276.5 291 L 277 293.5 L 276 293.5 L 276.5 291 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 912.5 291 L 913 296.5 L 912 296.5 L 912.5 291 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 47.5 292 L 48.5 294 L 47.5 292 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 49.5 295 L 51.5 298 L 49.5 295 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 536.5 295 L 534.5 298 L 536.5 295 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 652.5 296 L 660.5 305 L 652.5 296 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 1149.5 296 L 1150 307.5 L 1149 307.5 L 1149.5 296 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 275.5 297 L 276 299.5 L 275 299.5 L 275.5 297 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 879.5 297 L 880 299.5 L 879 299.5 L 879.5 297 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 52.5 299 L 54.5 302 L 52.5 299 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 531.5 301 L 527.5 306 L 531.5 301 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 274.5 302 L 275 304.5 L 274 304.5 L 274.5 302 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 911.5 303 L 912 309.5 L 911 309.5 L 911.5 303 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 56.5 304 L 58.5 307 L 56.5 304 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 60.5 309 L 66.5 316 L 60.5 309 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 665.5 309 L 673.5 318 L 665.5 309 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 910.5 317 L 911 325.5 L 910 325.5 L 910.5 317 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 512.5 320 L 508.5 325 L 512.5 320 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 679.5 322 L 681.5 325 L 679.5 322 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 77.5 326 L 81.5 331 L 77.5 326 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 685.5 327 L 686.5 329 L 685.5 327 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 265.5 328 L 264.5 330 L 265.5 328 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 503.5 328 L 502.5 330 L 503.5 328 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 1149.5 330 L 1150 343.5 L 1149 343.5 L 1149.5 330 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 690.5 331 L 691.5 333 L 690.5 331 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 498.5 332 L 497.5 334 L 498.5 332 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 85.5 333 L 87.5 336 L 85.5 333 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 262.5 333 L 261.5 335 L 262.5 333 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 864.5 333 L 863.5 335 L 864.5 333 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 694.5 334 L 695.5 336 L 694.5 334 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 909.5 335 L 910 346.5 L 909 346.5 L 909.5 335 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 89.5 336 L 91.5 339 L 89.5 336 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 260.5 336 L 259.5 338 L 260.5 336 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 698.5 337 L 699.5 339 L 698.5 337 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 490.5 338 L 489.5 340 L 490.5 338 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 860.5 338 L 851.5 348 L 860.5 338 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 93.5 339 L 94.5 341 L 93.5 339 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 323.5 339 L 324.5 341 L 323.5 339 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 257.5 340 L 255.5 343 L 257.5 340 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 327.5 344 L 336.5 354 L 327.5 344 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 102.5 345 L 103.5 347 L 102.5 345 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 252.5 346 L 250.5 349 L 252.5 346 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 713.5 347 L 714.5 349 L 713.5 347 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 107.5 348 L 108.5 350 L 107.5 348 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 847.5 350 L 846.5 352 L 847.5 350 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 246.5 351 L 244.5 354 L 246.5 351 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 1150.5 354 L 1151 361.5 L 1150 361.5 L 1150.5 354 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 339.5 355 L 340.5 357 L 339.5 355 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 908.5 362 L 909 385.5 L 908 385.5 L 908.5 362 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 153.5 366 L 156 366.5 L 153.5 367 L 153.5 366 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 158.5 367 L 161 367.5 L 158.5 368 L 158.5 367 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 164.5 368 L 167 368.5 L 164.5 369 L 164.5 368 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 208.5 368 L 211 368.5 L 208.5 369 L 208.5 368 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 762.5 368 L 765 368.5 L 762.5 369 L 762.5 368 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 804.5 368 L 807 368.5 L 804.5 369 L 804.5 368 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 1166.5 368 L 1169 368.5 L 1166.5 369 L 1166.5 368 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 171.5 369 L 176 369.5 L 171.5 370 L 171.5 369 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 201.5 369 L 205 369.5 L 201.5 370 L 201.5 369 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 769.5 369 L 773 369.5 L 769.5 370 L 769.5 369 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 797.5 369 L 801 369.5 L 797.5 370 L 797.5 369 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 1151.5 369 L 1157 370.5 L 1151 371 L 1151.5 369 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 1161.5 369 L 1164 369.5 L 1161.5 370 L 1161.5 369 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 183.5 370 L 194 370.5 L 183.5 371 L 183.5 370 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 415.5 370 L 418 370.5 L 415.5 371 L 415.5 370 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 782.5 370 L 789 370.5 L 782.5 371 L 782.5 370 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 382.5 371 L 387 371.5 L 382.5 372 L 382.5 371 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 406.5 371 L 411 371.5 L 406.5 372 L 406.5 371 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 22.5 373 L 22 374.5 L 21.5 1013 L 21 374.5 L 22.5 373 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 554.5 377 L 563 377.5 L 554.5 378 L 554.5 377 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 908.5 441 L 909 471.5 L 908 471.5 L 908.5 441 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 321.5 462 L 322 614.5 L 321 614.5 L 321.5 462 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 909.5 494 L 910 513.5 L 909 513.5 L 909.5 494 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 910.5 531 L 911 548.5 L 910 548.5 L 910.5 531 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 911.5 566 L 912 583.5 L 911 583.5 L 911.5 566 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 1159.5 569 L 1158.5 571 L 1159.5 569 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 1156.5 571 L 1152 576.5 L 1151.5 1013 L 1151 576.5 L 1156.5 571 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 912.5 603 L 913 624.5 L 912 624.5 L 912.5 603 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 913.5 653 L 914 1097.5 L 913 1097.5 L 913.5 653 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 321.5 768 L 322 848.5 L 321 848.5 L 321.5 768 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 322.5 891 L 323 921.5 L 322 921.5 L 322.5 891 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 323.5 948 L 324 969.5 L 323 969.5 L 323.5 948 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 324.5 989 L 325 1005.5 L 324 1005.5 L 324.5 989 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 325.5 1022 L 326 1035.5 L 325 1035.5 L 325.5 1022 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 326.5 1050 L 327 1061.5 L 326 1061.5 L 326.5 1050 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 327.5 1074 L 328 1084.5 L 327 1084.5 L 327.5 1074 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '0.7450980392156863',
        d: 'M 328.5 1096 L 330 1098.5 L 328 1099 L 328.5 1096 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '1',
        d: 'M 1225.5 1 L 1235.5 1 L 1236 1.5 L 1236 217 L 1215.5 211 L 1197.5 210 Q 1180.3 212.8 1171 223.5 Q 1163.5 232 1159 243.5 L 1152 269.5 L 1151 282.5 L 1150 283.5 L 1150 295.5 L 1149 296.5 L 1149 343.5 L 1150 344.5 L 1150 361.5 L 1151 362.5 L 1151 371 L 1163.5 370 L 1183.5 365 L 1236 346 L 1236 540.5 L 1234.5 542 L 1176.5 560 Q 1161.3 565.8 1151 576.5 L 1151 1013.5 L 1148.5 1014 L 996.5 1073 L 948.5 1089 L 914 1098 L 914 653.5 L 913 652.5 L 913 603.5 L 912 602.5 L 912 566.5 L 911 565.5 L 910 494.5 L 909 493.5 L 908 386.5 L 909 385.5 L 910 326.5 L 911 325.5 L 911 310.5 L 912 309.5 L 914 276.5 L 915 275.5 L 918 251.5 L 925 223.5 Q 949.8 146.3 1002.5 97 Q 1044 57 1100.5 32 Q 1131.5 18.5 1167.5 10 L 1199.5 4 L 1224.5 2 L 1225.5 1 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '1',
        d: 'M 76.5 76 L 99.5 76 L 100.5 77 L 107.5 77 L 117.5 79 L 153.5 92 Q 196.2 113.3 227 146.5 Q 251 171 265 205.5 L 275 240.5 L 276 252.5 L 277 253.5 L 278 277.5 L 277 278.5 L 277 290.5 L 274 306.5 L 268 323.5 Q 260.3 339.8 247.5 351 Q 224.3 372.8 176.5 370 L 143.5 364 L 121.5 356 Q 89.3 341.2 67 316.5 Q 46.3 294.2 31 266.5 Q 16.4 240.1 5 210.5 L 1 199.5 L 1 144.5 Q 11.2 114.2 32.5 95 Q 41.5 87 53.5 82 L 76.5 76 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '1',
        d: 'M 487.5 77 L 509.5 79 L 529.5 85 Q 548.6 93.4 561 108.5 Q 573.1 122.4 579 142.5 L 583 162.5 L 583 192.5 L 578 218.5 Q 571.3 240.8 561 259.5 Q 541.6 294.1 513.5 320 Q 488.7 343.7 455.5 359 L 433.5 367 L 420.5 370 L 406.5 371 L 405.5 372 L 387.5 372 L 386.5 371 L 378.5 371 L 368.5 369 L 353.5 364 Q 336.1 355.9 325 341.5 Q 313.8 327.2 308 307.5 L 303 281.5 L 303 255.5 L 307 232.5 L 312 216.5 L 327 184.5 Q 347.2 150.2 376.5 125 Q 398.4 105.4 426.5 92 L 457.5 81 L 473.5 78 L 486.5 78 L 487.5 77 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '1',
        d: 'M 682.5 77 L 707.5 77 Q 708.8 79.3 713.5 78 L 730.5 82 L 751.5 90 Q 796.7 111.8 828 147.5 Q 855.1 176.9 871 217.5 L 875 229.5 L 880 252.5 Q 878.2 258.7 881 260.5 L 881 289.5 L 877 309.5 L 871 323.5 Q 862.2 339.2 848.5 350 Q 835.4 360.4 817.5 366 L 796.5 370 L 773.5 370 L 772.5 369 L 759.5 368 L 743.5 363 L 720.5 352 Q 687.1 332.4 661 305.5 Q 629.1 274.4 609 231.5 Q 602 216.5 598 198.5 L 596 187.5 L 595 169.5 L 596 168.5 L 596 157.5 L 598 146.5 L 603 131.5 Q 612.8 108.8 630.5 94 L 650.5 84 L 682.5 77 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '1',
        d: 'M 22 374 L 260 462 L 260 1097.5 L 257.5 1098 L 107.5 1041 L 45.5 1020 L 22 1014 L 22 374 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '1',
        d: 'M 621 374 L 699.5 404 L 859 462 L 859 1097.5 L 856.5 1098 L 709.5 1044 L 621 1010 L 621 374 Z ',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        stroke: 'rgb(0,0,0)',
        strokeWidth: '1',
        opacity: '1',
        d: 'M 552.5 378 L 562.5 378 L 563 378.5 L 563 1010 L 513.5 1029 L 398.5 1070 L 329 1098 L 328 1095.5 L 327 1050.5 L 326 1049.5 L 326 1022.5 L 325 1021.5 L 324 948.5 L 323 947.5 L 323 891.5 L 322 890.5 L 321 615.5 L 322 614.5 L 322 462 L 390.5 439 L 552.5 378 Z ',
      },
      child: [],
    },
  ],
};

const iiifLogo = GenIcon(iiifJson);
export const IIIFLogoIcon = (props: React.ComponentPropsWithoutRef<'svg'>): React.JSX.Element =>
  iiifLogo(props);

// Kingdom icons — sourced from packages/gbif-org/src/routes/country/key/components/kingdoms/icons/
const animaliaJson = {
  tag: 'svg',
  attr: { viewBox: '0 0 57.7 57.7' },
  child: [
    {
      tag: 'path',
      attr: {
        d: 'M49.2,42.7L44.9,40l-3.6-6.3c-0.1-0.2-0.2-0.3-0.4-0.4c0-1.3-0.2-2.7-0.5-3.9l1.8,1.2c0.2,0.1,0.4,0.2,0.6,0.2c0.1,0,0.1,0,0.2,0l5.2-0.9c0.6-0.1,1-0.7,0.9-1.3c-0.1-0.6-0.7-1-1.3-0.9L43,28.5l-4.2-2.8c-0.5-0.8-1-1.4-1.6-2.1l3.7-2.1c0.2-0.1,0.4-0.4,0.5-0.6l1.6-4.8c0.2-0.6-0.1-1.2-0.7-1.4c-0.6-0.2-1.2,0.1-1.4,0.7l-1.5,4.4l-4,2.2c-0.4-0.3-0.9-0.6-1.3-0.8c1.5-0.3,2.3-1.1,1.5-3.1c-0.5-1.2-2.1-2.3-3.8-2.9l1.6-3.7c0.6-0.2,1-0.7,1-1.4c0-0.8-0.6-1.4-1.4-1.4c-0.8,0-1.4,0.6-1.4,1.4c0,0.2,0,0.4,0.1,0.5l-1.7,4c-0.4-0.1-0.7-0.1-1-0.1c-0.4,0-0.9,0.1-1.3,0.2l-1.7-4c0.1-0.2,0.1-0.4,0.1-0.6c0-0.8-0.6-1.4-1.4-1.4c-0.8,0-1.4,0.6-1.4,1.4c0,0.6,0.4,1.2,1,1.4l1.6,3.8c-1.6,0.6-3.2,1.6-3.9,2.7c-1.1,1.9-0.1,2.7,1.5,3.1c-0.5,0.3-1,0.6-1.5,0.9L18,19.8l-1.5-4.4c-0.2-0.6-0.8-0.9-1.4-0.7c-0.6,0.2-0.9,0.8-0.7,1.4L16,21c0.1,0.3,0.3,0.5,0.5,0.6l3.6,2c-0.5,0.5-1,1.1-1.4,1.8l-4.3,2.8l-4.8-0.8c-0.6-0.1-1.2,0.3-1.3,0.9c-0.1,0.6,0.3,1.2,0.9,1.3l5.2,0.9c0.1,0,0.1,0,0.2,0c0.2,0,0.4-0.1,0.6-0.2l1.9-1.1c-0.4,1.3-0.4,2.8-0.4,4.3c0,0,0,0,0,0c0,0.1-0.3,0.1-0.4,0.2L12.7,40l-4.3,2.7c-0.5,0.3-0.7,1-0.4,1.5c0.2,0.3,0.6,0.5,0.9,0.5c0.2,0,0.4-0.1,0.6-0.2l4.5-2.9c0.2-0.1,0.3-0.2,0.4-0.4l2.4-4.2c1.3,5.3,5.4,9.4,10.5,10l1.2-13.2L30,47.1c5.1-0.6,9.3-4.8,10.6-10.2l2.6,4.4c0.1,0.2,0.2,0.3,0.4,0.4l4.5,2.9c0.2,0.1,0.4,0.2,0.6,0.2c0.4,0,0.7-0.2,0.9-0.5C49.8,43.8,49.7,43.1,49.2,42.7z M23.8,40.1c-1.1,0.4-2.3-0.4-2.7-1.6s0.2-2.5,1.3-2.9s2.3,0.4,2.7,1.6C25.5,38.4,24.9,39.7,23.8,40.1z M25.6,29.9c-0.3,0.9-1.2,1.3-1.9,1.1c-0.8-0.3-1.1-1.2-0.8-2s1.2-1.3,1.9-1.1C25.5,28.1,25.9,29,25.6,29.9z M32.5,27.4c0.8-0.3,1.6,0.2,1.9,1.1s-0.1,1.8-0.8,2c-0.8,0.3-1.6-0.2-1.9-1.1C31.4,28.6,31.8,27.7,32.5,27.4z M36,38.5c-0.4,1.2-1.6,1.9-2.7,1.6s-1.7-1.6-1.3-2.9c0.4-1.2,1.6-1.9,2.7-1.6S36.4,37.3,36,38.5z',
      },
      child: [],
    },
  ],
};
const animalia = GenIcon(animaliaJson);
export const AnimaliaIcon = (props: React.ComponentPropsWithoutRef<'svg'>): React.JSX.Element =>
  animalia(props);

const archaeaJson = {
  tag: 'svg',
  attr: { viewBox: '0 0 57.7 57.7' },
  child: [
    {
      tag: 'ellipse',
      attr: {
        transform: 'matrix(0.7381 -0.6747 0.6747 0.7381 -9.9515 24.4811)',
        cx: '26.6',
        cy: '25.1',
        rx: '3.4',
        ry: '2.7',
      },
      child: [],
    },
    {
      tag: 'ellipse',
      attr: {
        transform: 'matrix(0.9957 -9.231137e-02 9.231137e-02 0.9957 -1.4426 2.201)',
        cx: '23.1',
        cy: '16.7',
        rx: '3.6',
        ry: '2.8',
      },
      child: [],
    },
    {
      tag: 'ellipse',
      attr: {
        transform: 'matrix(0.3627 0.9319 -0.9319 0.3627 33.6876 -16.5535)',
        cx: '28.9',
        cy: '16.4',
        rx: '2.9',
        ry: '2.3',
      },
      child: [],
    },
    {
      tag: 'ellipse',
      attr: {
        transform: 'matrix(0.9279 0.3729 -0.3729 0.9279 9.6716 -6.057)',
        cx: '20.5',
        cy: '22',
        rx: '3.8',
        ry: '2.8',
      },
      child: [],
    },
    {
      tag: 'ellipse',
      attr: {
        transform: 'matrix(0.5952 -0.8036 0.8036 0.5952 -6.2181 19.3201)',
        cx: '16.1',
        cy: '15.8',
        rx: '4',
        ry: '3.2',
      },
      child: [],
    },
    {
      tag: 'ellipse',
      attr: {
        transform: 'matrix(-0.326 -0.9454 0.9454 -0.326 -2.1328 43.7397)',
        cx: '14.5',
        cy: '22.6',
        rx: '3.1',
        ry: '2.1',
      },
      child: [],
    },
    {
      tag: 'ellipse',
      attr: {
        transform: 'matrix(-0.9698 -0.2439 0.2439 -0.9698 32.5703 57.992)',
        cx: '19.9',
        cy: '27',
        rx: '4.1',
        ry: '2.1',
      },
      child: [],
    },
    {
      tag: 'ellipse',
      attr: {
        transform: 'matrix(-0.9664 0.257 -0.257 -0.9664 42.2635 16.9998)',
        cx: '20',
        cy: '11.3',
        rx: '2.3',
        ry: '1.7',
      },
      child: [],
    },
    {
      tag: 'ellipse',
      attr: {
        transform: 'matrix(-0.9467 -0.322 0.322 -0.9467 44.9185 31.3811)',
        cx: '25.1',
        cy: '12',
        rx: '2.8',
        ry: '2',
      },
      child: [],
    },
    {
      tag: 'ellipse',
      attr: {
        transform: 'matrix(0.8749 -0.4843 0.4843 0.8749 -6.6284 15.2637)',
        cx: '26.2',
        cy: '20.5',
        rx: '2',
        ry: '1.6',
      },
      child: [],
    },
    {
      tag: 'ellipse',
      attr: {
        transform: 'matrix(-0.1579 0.9875 -0.9875 -0.1579 55.7266 -5.1312)',
        cx: '30.1',
        cy: '21.2',
        rx: '2',
        ry: '1.6',
      },
      child: [],
    },
    {
      tag: 'ellipse',
      attr: {
        transform: 'matrix(0.9543 0.299 -0.299 0.9543 12.141 -9.832)',
        cx: '38.2',
        cy: '34.8',
        rx: '3.4',
        ry: '2.7',
      },
      child: [],
    },
    {
      tag: 'ellipse',
      attr: {
        transform: 'matrix(0.5803 0.8144 -0.8144 0.5803 40.7689 -24.0141)',
        cx: '43.7',
        cy: '27.5',
        rx: '3.6',
        ry: '2.8',
      },
      child: [],
    },
    {
      tag: 'ellipse',
      attr: {
        transform: 'matrix(-0.6234 0.7819 -0.7819 -0.6234 101.5626 15.9876)',
        cx: '46.9',
        cy: '32.5',
        rx: '2.9',
        ry: '2.3',
      },
      child: [],
    },
    {
      tag: 'ellipse',
      attr: {
        transform: 'matrix(0.144 0.9896 -0.9896 0.144 60.0563 -13.4843)',
        cx: '37.8',
        cy: '28',
        rx: '3.8',
        ry: '2.8',
      },
      child: [],
    },
    {
      tag: 'ellipse',
      attr: {
        transform: 'matrix(0.9939 0.1107 -0.1107 0.9939 2.5816 -4.3978)',
        cx: '40.9',
        cy: '21.1',
        rx: '4',
        ry: '3.2',
      },
      child: [],
    },
    {
      tag: 'ellipse',
      attr: {
        transform: 'matrix(0.6535 -0.7569 0.7569 0.6535 -5.6469 33.9495)',
        cx: '34.3',
        cy: '23.1',
        rx: '3.1',
        ry: '2.1',
      },
      child: [],
    },
    {
      tag: 'ellipse',
      attr: {
        transform: 'matrix(-0.2766 -0.961 0.961 -0.2766 13.5793 70.1264)',
        cx: '33.2',
        cy: '30',
        rx: '4.1',
        ry: '2.1',
      },
      child: [],
    },
    {
      tag: 'ellipse',
      attr: {
        transform: 'matrix(-0.7079 -0.7063 0.7063 -0.7079 64.343 70.9667)',
        cx: '46.8',
        cy: '22.2',
        rx: '2.3',
        ry: '1.7',
      },
      child: [],
    },
    {
      tag: 'ellipse',
      attr: {
        transform: 'matrix(-0.1975 -0.9803 0.9803 -0.1975 32.0282 79.9971)',
        cx: '48.8',
        cy: '26.9',
        rx: '2.8',
        ry: '2',
      },
      child: [],
    },
    {
      tag: 'ellipse',
      attr: {
        transform: 'matrix(0.8584 0.5129 -0.5129 0.8584 22.4477 -16.9953)',
        cx: '42',
        cy: '32.2',
        rx: '2',
        ry: '1.6',
      },
      child: [],
    },
    {
      tag: 'ellipse',
      attr: {
        transform: 'matrix(-0.933 0.3598 -0.3598 -0.933 96.5939 53.7066)',
        cx: '43.3',
        cy: '35.8',
        rx: '2',
        ry: '1.6',
      },
      child: [],
    },
    {
      tag: 'ellipse',
      attr: {
        transform: 'matrix(-0.1341 -0.991 0.991 -0.1341 -3.7457 76.2801)',
        cx: '31.5',
        cy: '39.8',
        rx: '3.4',
        ry: '2.7',
      },
      child: [],
    },
    {
      tag: 'ellipse',
      attr: {
        transform: 'matrix(0.4914 -0.871 0.871 0.4914 -21.4965 38.9446)',
        cx: '22.6',
        cy: '37.9',
        rx: '3.6',
        ry: '2.8',
      },
      child: [],
    },
    {
      tag: 'ellipse',
      attr: {
        transform: 'matrix(0.9725 0.2328 -0.2328 0.9725 8.3547 -5.0718)',
        cx: '25.7',
        cy: '32.9',
        rx: '2.9',
        ry: '2.3',
      },
      child: [],
    },
    {
      tag: 'ellipse',
      attr: {
        transform: 'matrix(0.835 -0.5502 0.5502 0.835 -19.4585 21.1057)',
        cx: '25.5',
        cy: '43',
        rx: '3.8',
        ry: '2.8',
      },
      child: [],
    },
    {
      tag: 'ellipse',
      attr: {
        transform: 'matrix(-0.3214 -0.9469 0.9469 -0.3214 -17.2052 73.9536)',
        cx: '17.9',
        cy: '43.1',
        rx: '4',
        ry: '3.2',
      },
      child: [],
    },
    {
      tag: 'ellipse',
      attr: {
        transform: 'matrix(-0.9627 -0.2707 0.2707 -0.9627 31.3003 100.8778)',
        cx: '22.6',
        cy: '48.3',
        rx: '3.1',
        ry: '2.1',
      },
      child: [],
    },
    {
      tag: 'ellipse',
      attr: {
        transform: 'matrix(-0.7529 0.6581 -0.6581 -0.7529 81.7465 62.0334)',
        cx: '29.2',
        cy: '46.4',
        rx: '4.1',
        ry: '2.1',
      },
      child: [],
    },
    {
      tag: 'ellipse',
      attr: {
        transform: 'matrix(-0.3393 0.9407 -0.9407 -0.3393 57.031 34.5221)',
        cx: '16.4',
        cy: '37.3',
        rx: '2.3',
        ry: '1.7',
      },
      child: [],
    },
    {
      tag: 'ellipse',
      attr: {
        transform: 'matrix(-0.804 0.5947 -0.5947 -0.804 55.7601 48.7358)',
        cx: '19.8',
        cy: '33.6',
        rx: '2.8',
        ry: '2',
      },
      child: [],
    },
    {
      tag: 'ellipse',
      attr: {
        transform: 'matrix(0.1003 -0.995 0.995 0.1003 -12.5065 61.0234)',
        cx: '27.5',
        cy: '37.4',
        rx: '2',
        ry: '1.6',
      },
      child: [],
    },
    {
      tag: 'ellipse',
      attr: {
        transform: 'matrix(0.7216 0.6923 -0.6923 0.7216 32.4526 -11.2957)',
        cx: '30.3',
        cy: '34.7',
        rx: '2',
        ry: '1.6',
      },
      child: [],
    },
  ],
};
const archaea = GenIcon(archaeaJson);
export const ArchaeaIcon = (props: React.ComponentPropsWithoutRef<'svg'>): React.JSX.Element =>
  archaea(props);

const bacteriaJson = {
  tag: 'svg',
  attr: { viewBox: '0 0 57.7 57.7' },
  child: [
    {
      tag: 'path',
      attr: {
        d: 'M19,35.2L19,35.2c7.5-7.5,9.2-15.8,9.6-17.1c0.3-0.8,0.4-1.5,0.4-2.3c0-2.8-2.3-5-5-5c-2.5,0-4.6,1.7-5,4.1l0,0.1c-1.3,7.1-4.8,11.1-6.5,12.7c-0.3,0.2-0.6,0.5-0.9,0.7c0,0-0.1,0-0.1,0l0,0c-0.8,0.9-1.3,2.1-1.3,3.4c0,2.8,2.3,5,5,5C16.7,37,18.1,36.3,19,35.2z',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        d: 'M43.7,34.7c-1.3-1.3-8.3-8.6-10.9-10.7c0,0-2.2-1.6-4.2-0.5c0,0-0.3,0.1-0.7,1.1c-1,2.3-2.6,4.9-2.6,4.9c0.4,1.4,1.1,2.2,1.1,2.2l10.1,10.1l0.1,0.1c1.1,1.2,2.3,1.8,3.9,1.8c2.8,0,5-2.3,5-5C45.5,37,44.8,35.6,43.7,34.7z',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        d: 'M22.2,37.4c-2.1,0.6-3.6,2.5-3.6,4.8c0,2.8,2.3,5,5,5c0.8,0,1.5-0.2,2.2-0.5l0,0l9.1-4.7l-7.5-7.2C27.3,34.9,22.2,37.4,22.2,37.4z',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        d: 'M33.2,22.5c0.8,0.6,1.9,1.7,3.1,2.9c0.8,0.6,1.4,0.6,2.2,0.6c2.8,0,5-2.4,5-5.1s-2.3-5-5-5l-8.3,0.1c-0.3,2.5-1.4,6.2-1.4,6.2c0,0,0,0,0,0C29,22,29,22,29,22C31.6,21.2,33.2,22.5,33.2,22.5z',
      },
      child: [],
    },
  ],
};
const bacteria = GenIcon(bacteriaJson);
export const BacteriaIcon = (props: React.ComponentPropsWithoutRef<'svg'>): React.JSX.Element =>
  bacteria(props);

const chromistaJson = {
  tag: 'svg',
  attr: { viewBox: '0 0 57.7 57.7' },
  child: [
    {
      tag: 'path',
      attr: {
        d: 'M47.8,26.1l-2.2-0.9c-4.6-1.8-9.8-7-11.6-11.6l-0.9-2.2c-1.8-4.6-4.7-4.6-6.5,0l-0.9,2.2c-1.8,4.6-7,9.8-11.6,11.6l-2.2,0.9c-4.6,1.8-4.6,4.7,0,6.5l2.2,0.9c4.6,1.8,9.8,7,11.6,11.6l0.9,2.2c1.8,4.6,4.7,4.6,6.5,0L34,45c1.8-4.6,7-9.8,11.6-11.6l2.2-0.9C52.3,30.8,52.3,27.9,47.8,26.1z M22.9,35.1c-0.8,0.4-1.8,0.1-2.3-0.7c-0.4-0.8-0.1-1.8,0.7-2.3c0.8-0.4,1.8-0.1,2.3,0.7C24,33.7,23.7,34.7,22.9,35.1z M23.8,25.8c-0.5,0.8-1.5,1-2.3,0.5c-0.8-0.5-1-1.5-0.5-2.3c0.5-0.8,1.5-1,2.3-0.5C24,23.9,24.3,25,23.8,25.8z M29.7,19.1c0.9,0,1.7,0.8,1.7,1.7c0,0.9-0.8,1.7-1.7,1.7S28,21.8,28,20.8C28,19.9,28.8,19.1,29.7,19.1z M29.7,39.9c-0.9,0-1.7-0.8-1.7-1.7s0.8-1.7,1.7-1.7s1.7,0.8,1.7,1.7S30.6,39.9,29.7,39.9z M29.7,32.2c-1.5,0-2.7-1.2-2.7-2.7c0-1.5,1.2-2.7,2.7-2.7c1.5,0,2.7,1.2,2.7,2.7C32.4,31,31.2,32.2,29.7,32.2z M38.5,35c-0.5,0.8-1.5,1-2.3,0.5c-0.8-0.5-1-1.5-0.5-2.3c0.5-0.8,1.5-1,2.3-0.5C38.7,33.2,39,34.2,38.5,35z M38.1,26.8c-0.8,0.4-1.8,0.1-2.3-0.7c-0.4-0.8-0.1-1.8,0.7-2.3c0.8-0.4,1.8-0.1,2.3,0.7C39.2,25.4,38.9,26.4,38.1,26.8z',
      },
      child: [],
    },
  ],
};
const chromista = GenIcon(chromistaJson);
export const ChromistaIcon = (props: React.ComponentPropsWithoutRef<'svg'>): React.JSX.Element =>
  chromista(props);

const fungiKingdomJson = {
  tag: 'svg',
  attr: { viewBox: '0 0 57.7 57.7' },
  child: [
    {
      tag: 'path',
      attr: {
        d: 'M42.9,28.5c-0.5-0.5-1.2-0.5-1.7-0.1c-5.4,5-8.5,9.9-10.2,13.7c1.2-11.5,8-19.6,8.1-19.7c0.4-0.5,0.4-1.3-0.1-1.7c-0.5-0.4-1.3-0.4-1.7,0.1c-0.4,0.4-7.5,9-8.7,21.3c-0.9-4.2-1.7-10.1-1-16.4c0.1-0.7-0.4-1.3-1.1-1.3c-0.7-0.1-1.3,0.4-1.3,1.1c-0.9,8.1,0.5,15.3,1.7,19.7c-7.6-8.3-10-21.9-10-22.1c-0.1-0.7-0.7-1.1-1.4-1c-0.7,0.1-1.1,0.7-1,1.4c0.1,0.8,3.2,18.5,14.2,26.5c0.1,0.1,0.3,0.1,0.4,0.1c0.2,0.2,0.5,0.3,0.8,0.3c0,0,0,0,0,0c0.6,0,1.1-0.4,1.2-1c0-0.1,1.3-9.6,11.8-19.3C43.3,29.7,43.4,29,42.9,28.5z',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        d: 'M20.5,19.1c-0.3-2.7-2.7-4.6-5.5-4.5c-2.7,0.1-4.8,2.3-5,5c-0.1,0.6,0,0.5,0.1,1.2c0,0,0.1,1.7,2.4,1.2l6.6-1.3C19,20.6,20.6,20.5,20.5,19.1z',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        d: 'M31.1,22.9c0.2-2.1-1.2-4.1-3.4-4.5c-2.1-0.4-4.1,0.8-4.8,2.9c-0.2,0.5-0.1,0.4-0.2,1c0,0-0.2,1.3,1.6,1.4l5.4,0.2C29.7,23.8,31,24,31.1,22.9z',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        d: 'M47.3,30.4c1.6-1.4,1.8-3.9,0.5-5.6c-1.3-1.7-3.7-2.1-5.5-1c-0.4,0.3-0.4,0.2-0.8,0.6c0,0-1,0.8,0.3,2.1l3.9,3.7C45.7,30.2,46.5,31.2,47.3,30.4z',
      },
      child: [],
    },
    {
      tag: 'path',
      attr: {
        d: 'M44.5,21.8c1.6-2.1,1.2-5.3-0.8-7.1c-2-1.8-5.1-1.7-7.1,0.1c-0.5,0.4-0.4,0.4-0.8,0.9c0,0-1.1,1.3,0.9,2.5l5.7,3.6C42.4,21.9,43.7,23,44.5,21.8z',
      },
      child: [],
    },
  ],
};
const fungiKingdom = GenIcon(fungiKingdomJson);
export const FungiKingdomIcon = (props: React.ComponentPropsWithoutRef<'svg'>): React.JSX.Element =>
  fungiKingdom(props);

const plantaeJson = {
  tag: 'svg',
  attr: { viewBox: '0 0 57.7 57.7' },
  child: [
    {
      tag: 'path',
      attr: {
        d: 'M48.2,17.8c0,0-1,2.9-9.4,3.8c-8.4,0.9-9.8,8.7-8.7,11.5c0,0,2.6-2.3,6.6-3.6s8-3.3,9.8-6.4c0,0-1.4,5.1-9.5,8.1c-8,3-11.3,10.4-11.3,10.4s-3.3-4.5-5.4-5.7c-2.1-1.3-8.5-5.4-9.1-9.9c0,0,2.2,3.9,4.8,5.3s6.3,3.3,8.8,6.4c0,0,1.2-2.8,0.5-5.9c-0.7-3.1-3.1-5.5-7-6.5c-3.9-1-6.5-2.2-8.2-4.9c0,0-3.9,6.8-0.9,14.8s11.8,6.4,13,5.5c0,0,2.8,1.7,3.3,5.1l3.5,0.2c0,0-1.1-6.4,3.4-9.3c0,0,7.8,3.5,12.6-0.9S51.1,23.3,48.2,17.8z',
      },
      child: [],
    },
  ],
};
const plantae = GenIcon(plantaeJson);
export const PlantaeIcon = (props: React.ComponentPropsWithoutRef<'svg'>): React.JSX.Element =>
  plantae(props);

const protozoaJson = {
  tag: 'svg',
  attr: { viewBox: '0 0 57.7 57.7' },
  child: [
    {
      tag: 'path',
      attr: {
        d: 'M43.6,32.1L43.6,32.1c0,0-4.2-1.8-1.5-7.1l0,0c1-1.1,1.6-2.5,1.6-4.1c0-3.3-2.7-6-6-6c-1.5,0-2.9,0.6-4,1.5c-1,0.7-3.7,2.2-5.9-0.6l0,0c-0.9-1.8-2.8-3.1-4.9-3.1c-3.1,0-5.5,2.5-5.5,5.5c0,0.8,0.2,1.6,0.5,2.2l0,0c0,0,1.5,4.4-2.9,6.3c-0.1,0-0.1,0.1-0.2,0.1c-3.2,0.5-5.6,3.3-5.6,6.6c0,3.7,3,6.7,6.7,6.7c1.3,0,2.5-0.4,3.6-1c0,0,0.1,0.1,0.1,0.1s5.8-2.7,8.1,2.4l0.1,0c0.5,1.5,1.9,2.6,3.6,2.6c1.2,0,2.3-0.5,2.9-1.4l0,0c0,0,2.4-2,6.5-1.9l0,0c0,0,0.1,0,0.1,0c2.7,0,4.9-2.2,4.9-4.9C45.7,34.4,44.8,33,43.6,32.1z M25.5,25.8c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S26.6,25.8,25.5,25.8z M31.8,35.2c-2.2,0-4-1.8-4-4c0-2.2,1.8-4,4-4c2.2,0,4,1.8,4,4C35.8,33.4,34,35.2,31.8,35.2z',
      },
      child: [],
    },
    {
      tag: 'circle',
      attr: { cx: '25.5', cy: '23.8', r: '1.2' },
      child: [],
    },
  ],
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const protozoa = GenIcon(protozoaJson as any);
export const ProtozoaIcon = (props: React.ComponentPropsWithoutRef<'svg'>): React.JSX.Element =>
  protozoa(props);

const unknownKingdomJson = {
  tag: 'svg',
  attr: { viewBox: '0 0 57.7 57.7' },
  child: [
    {
      tag: 'path',
      attr: {
        d: 'M21.7,11.6c1.8-1.2,4.1-1.8,6.8-1.8c3.5,0,6.5,0.8,8.8,2.5s3.5,4.2,3.5,7.5c0,2-0.5,3.7-1.5,5.1c-0.6,0.8-1.7,1.9-3.4,3.2l-1.7,1.3c-0.9,0.7-1.5,1.5-1.8,2.5c-0.2,0.6-0.3,1.5-0.3,2.8h-6.4c0.1-2.6,0.3-4.5,0.7-5.5c0.4-1,1.4-2.2,3.1-3.5l1.7-1.3c0.6-0.4,1-0.9,1.4-1.4c0.6-0.9,0.9-1.8,0.9-2.8c0-1.2-0.3-2.3-1-3.2c-0.7-1-2-1.5-3.8-1.5c-1.8,0-3.1,0.6-3.8,1.8s-1.1,2.5-1.1,3.8h-6.8C17.2,16.7,18.8,13.5,21.7,11.6z M25.6,38h7v6.8h-7V38z',
      },
      child: [],
    },
  ],
};
const unknownKingdom = GenIcon(unknownKingdomJson);
export const UnknownKingdomIcon = (
  props: React.ComponentPropsWithoutRef<'svg'>
): React.JSX.Element => unknownKingdom(props);

const virusesJson = {
  tag: 'svg',
  attr: { viewBox: '0 0 57.7 57.7' },
  child: [
    {
      tag: 'path',
      attr: {
        d: 'M47.8,23.7c-0.9,0.1-1.8,0.6-2.3,1.3c-0.3,0.2-1.3,1.6-3.6,1.5c-1.3-0.1-2-0.3-2.4-0.5c-0.6-2.1-1.9-4-3.6-5.4c1-1.4,2.4-2.1,2.6-2.2c0.7-0.1,1.3-0.5,1.7-1c1-1.2,0.7-3-0.5-4c-1.2-1-3-0.7-4,0.5c-0.5,0.6-0.7,1.4-0.6,2.1c0,0.3-0.2,1.9-1.3,3.3c-1.3-0.7-2.8-1-4.3-1.1c-0.4-0.1-1-0.7-1.5-2.3c-0.7-2.2,0.1-3.6,0.2-3.9c0.4-0.7,0.6-1.5,0.5-2.4c-0.3-1.8-2.1-3.1-3.9-2.7c-1.8,0.3-3.1,2.1-2.7,3.9c0.2,0.9,0.7,1.7,1.4,2.2c0.3,0.3,1.7,1.2,1.8,3.5c0,1.4-0.2,2.2-0.4,2.5c-1.8,0.7-3.3,1.9-4.4,3.3c-1.2-1-1.8-2.3-1.9-2.6c-0.1-0.7-0.4-1.3-1-1.8c-1.2-1-3-0.9-4,0.3c-1,1.2-0.9,3,0.3,4c0.6,0.5,1.4,0.7,2.1,0.7c0.3,0,1.8,0.3,3.1,1.4c-0.7,1.4-1.1,3.1-1.1,4.8c0,0.4,0,0.8,0.1,1.2c-0.1,0.4-0.6,1.1-2.1,1.8c-2.1,1-3.5,0.4-3.9,0.3c-0.7-0.3-1.6-0.4-2.4-0.2C8,32.9,7,34.8,7.6,36.6c0.6,1.8,2.4,2.7,4.2,2.2c0.9-0.3,1.6-0.9,2-1.7c0.3-0.3,0.9-1.8,3.3-2.2c1.7-0.3,2.4-0.1,2.8,0.1c0.8,1.3,1.8,2.4,3.1,3.2c-0.8,1.6-2.3,2.4-2.5,2.6c-0.7,0.2-1.2,0.6-1.6,1.2c-0.8,1.3-0.5,3.1,0.9,3.9c1.3,0.8,3.1,0.5,3.9-0.9c0.4-0.7,0.5-1.5,0.4-2.2c0-0.3,0.1-2,1.1-3.5c1.2,0.5,2.4,0.7,3.8,0.8l0,0c0,0,0,0,0.1,0c0.1,0,0.1,0,0.2,0c0.4,0.1,1.1,0.5,1.7,2.3c0.7,2.2,0,3.6-0.1,3.9c-0.4,0.7-0.6,1.5-0.4,2.4c0.4,1.8,2.1,3,3.9,2.7c1.8-0.4,3-2.1,2.7-3.9c-0.2-0.9-0.7-1.7-1.5-2.2c-0.3-0.3-1.7-1.2-1.8-3.5c-0.1-2,0.3-2.6,0.5-2.8c1.2-0.6,2.2-1.4,3.1-2.3c1.5,1,2.2,2.4,2.3,2.7c0.1,0.7,0.5,1.3,1,1.7c1.2,1,3,0.7,4-0.5c1-1.2,0.7-3-0.5-4c-0.6-0.5-1.4-0.7-2.1-0.6c-0.3,0-1.9-0.3-3.3-1.3c0.7-1.2,1.2-2.6,1.4-4.1c0.2-0.4,0.8-0.9,2.4-1.3c2.3-0.5,3.6,0.3,3.9,0.5c0.6,0.5,1.5,0.7,2.3,0.7c1.8-0.2,3.2-1.8,3-3.7C51.3,24.9,49.7,23.5,47.8,23.7z M24.5,31.1c-1.6,0-2.8-1.3-2.8-2.8s1.3-2.8,2.8-2.8s2.8,1.3,2.8,2.8S26.1,31.1,24.5,31.1z M30.6,36.3c-1.2,0-2.2-1-2.2-2.2s1-2.2,2.2-2.2s2.2,1,2.2,2.2S31.9,36.3,30.6,36.3z M32.8,29.4c-1.2,0-2.2-1-2.2-2.2c0-1.2,1-2.2,2.2-2.2c1.2,0,2.2,1,2.2,2.2C35,28.4,34,29.4,32.8,29.4z',
      },
      child: [],
    },
  ],
};
const viruses = GenIcon(virusesJson);
export const VirusesIcon = (props: React.ComponentPropsWithoutRef<'svg'>): React.JSX.Element =>
  viruses(props);
